export default __webpack_public_path__ + "static/new8-07-f50260a8cefd1f05161fd9afb80a38e4.jpg";